import type { FC, ReactElement } from "react"

import {
    ETypographyAlignment,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    Typography
} from "@/3514/components"
import { type IUseTranslation, useTranslation } from "@/hooks"

const Heading: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <Typography
            text={t("coachSide.welcomePage.heading")}
            alignment={ETypographyAlignment.Center}
            tag={ETypographyTag.Heading1}
            weight={ETypographyWeight.Medium}
            size={ETypographySize.Heading1}
            family={ETypographyFamily.DmSerif}
            className="mb-4"
        />
    )
}

export { Heading as CoachWelcomeHeading }
